import { NodeJsonExporter } from "../Node";
export class PolyNodeJsonExporter extends NodeJsonExporter {
  nodes_data(options = {}) {
    if (options.showPolyNodesData) {
      return super.nodes_data(options);
    }
    return {};
  }
  uiData(options = {}) {
    if (options.showPolyNodesData) {
      return super.uiData(options);
    } else {
      return this.ui_data_without_children();
    }
  }
}
